module.exports = __webpack_public_path__ + "static/media/star_rating.cb0182a9.png";